var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoCircleBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 50,
    viewBox: "0 0 44 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6214 0L43.2429 12.5V37.5L21.6214 50L0 37.5V12.5L21.6214 0Z",
    fill: "#1C2743"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.7841 31.5918C31.0477 30.1011 31.8908 28.2427 32.1302 26.1998H33.9408C33.6887 28.7388 32.6453 31.045 31.0606 32.8682L29.7841 31.5918ZM28.5043 32.8575C26.7388 34.3206 24.4721 35.2 22 35.2C19.6025 35.2 17.3983 34.3729 15.657 32.9884L14.3771 34.2682C16.4499 35.975 19.1053 37 22 37C24.9693 37 27.6866 35.9216 29.7818 34.135L28.5043 32.8575ZM22 13C28.4262 13 33.6726 18.0512 33.9853 24.3998H32.1826C31.872 19.0459 27.4318 14.8 22 14.8C16.3667 14.8 11.8 19.3667 11.8 25C11.8 27.5876 12.7635 29.9501 14.3514 31.7484L13.0765 33.0233C11.1639 30.8975 10 28.0847 10 25C10 18.3726 15.3726 13 22 13Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoCircleBox);
export default __webpack_public_path__ + "static/media/ico-circle-box.c23c2fb5ab9d48439990b86faf54ae9d.svg";
export { ForwardRef as ReactComponent };